














import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { DepositCollectionWithModelInAdmin } from '@/modules/deposit/models/deposit-collection.model'
import DepositPayableTypeView from '@/modules/deposit/components/shared/DepositPayableTypeView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import DepositStatusView from '@/modules/deposit/components/shared/DepositStatusView.vue'
import AdminDepositActions from '@/modules/deposit/components/admin/table/AdminDepositActions.vue'
import ShebaView from '@/modules/shared/components/shared/ShebaView.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import BankAccountTypeView from '@/modules/bank-account/components/shared/BankAccountTypeView.vue'

@Component({
  components: {
    ShebaView,
    CopyableText,
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped
  }
})
export default class AdminDepositTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  depositsWithData!: DepositCollectionWithModelInAdmin

  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    payable_type: {
      component: DepositPayableTypeView,
      handler: (value, row, withData) => ({ type: row.payable_type, types: withData.payable_types })
    },
    created_at: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    amount: {
      component: PriceView,
      handler: (value) => ({ price: value, noCurrency: true })
    },
    account_owner_name: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    account_type: {
      component: BankAccountTypeView,
      handler: (value, row, withData) => ({ type: value, types: withData.account_types })
    },
    status: {
      component: DepositStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    actions: {
      component: AdminDepositActions,
      handler: (value, row, withData) => ({ deposit: row, withData: withData })
    }
  }

}
